import { useEffect } from 'react';
import { useLocation, useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const CallbackMyAccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { login, setLoginError } = useAuth();

  const params = new URLSearchParams(location.search);
  const code = params.get('code');
  const error = params.get('error');
  const errorDescription = params.get('error_description');
  const state = params.get('state');
  const storedState = sessionStorage.getItem('state');

  useEffect(() => {
    // Early exit for error from provider or bad state
  if (error || !code || !state || storedState !== state) {
    const errorMessage = error
      ? `${error}: ${errorDescription || 'No additional error description provided.'}`
      : 'Invalid code or state.';
    setLoginError(errorMessage);
    return <Navigate to="/login" replace />;
  }
    const handleCallback = async () => {
      const codeVerifier = sessionStorage.getItem('code_verifier');
      if (!codeVerifier) {
        const msg = 'Code verifier is missing.';
        setLoginError(msg);
        console.error(msg);
        return navigate('/login');
      }

      try {
        const response = await fetch(`/api/auth/myaccess`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            code:code,
            codeVerifier:codeVerifier
          }),
        });

        if (response.status === 200) {
          const responseData = await response.json();
          const idToken = responseData.data.id_token;
          if (idToken) {
            login(idToken, responseData.email, responseData.roles);
            setLoginError(null);
            sessionStorage.setItem('receivedState', state); // optional if you use it
            navigate('/');
          } else {
            throw new Error('ID token missing in response');
          }
        } else {
          throw new Error(`Login failed: ${response.statusText}`);
        }
      } catch (err) {
        console.error('MyAccess callback error:', err);
        setLoginError('Login failed. Please try again.');
        navigate('/login');
      }
    };

    handleCallback();
  }, [code, state, login, setLoginError, navigate]);

  return <div>Processing login with MyAccess...</div>;
};

export default CallbackMyAccess;